import 'core-js';
import Vue from "vue";
import Vuetify from "vuetify";
import "../../node_modules/vuetify/dist/vuetify.min.css";
import "../../node_modules/@mdi/font/css/materialdesignicons.css";
import TeacherRequest from "./components/TeacherRequestComponent.vue";
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, { siteKey: window.___captcha });
Vue.use(Vuetify, { iconfont: "mdi" });
//Vue.component('teacher-request', TeacherRequest);

const app = new Vue({
    el: '#app',
    vuetify: new Vuetify(),
    render: h => h(TeacherRequest, {
        props: window.__INIT_DATA
    })
});
